var TagalysCustomisations = {};

TagalysCustomisations.analyticsStorageConsentFromShopify = function () {
  var cp = typeof window !== "undefined" && window.Shopify && window.Shopify.customerPrivacy;
  if (cp && typeof cp.analyticsProcessingAllowed === "function") {
    return cp.analyticsProcessingAllowed();
  }
  return true;
};

TagalysCustomisations.setTagalysConfiguration = function () {
  if (typeof window.Tagalys === "undefined" || typeof window.Tagalys.setConfiguration !== "function") {
    return;
  }
  var t = {
    api: {
      serverUrl: "https://api-r3.tagalys.com",
      credentials: {
        clientCode: "18C4A724F70FC2AF",
        apiKey: "4b177f9401b0f4873b912b9f29e28dad"
      },
      storeId: "14746976"
    },
    locale: "en-US",
    currency: {
      displayFormatter: "{{currencyLabel}}{{value}}",
      code: "USD",
      label: "$",
      fractionalDigits: 2,
      forceFractionalDigits: true
    },
    analyticsStorageConsentProvided: TagalysCustomisations.analyticsStorageConsentFromShopify,
    track: true
  };
  Tagalys.setConfiguration(t);
  var accepting = TagalysCustomisations.analyticsStorageConsentFromShopify();
  var privacyReady = !!(window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === "function");
  console.log(
    "[Tagalys] Initialized; analytics storage consent:",
    accepting ? "accepting" : "not accepting",
    privacyReady ? "(Customer Privacy API)" : "(fallback — API not loaded)"
  );
};

TagalysCustomisations.setPlatformConfiguration = function () {
  var platformConfiguration = {
    platform: "Shopify",
    countryCode: "US",
    baseCountryCode: "US",
    useStorefrontAPIForSecondaryMarkets: true,
    waitForStorefrontAPI: true,
    storefrontAPI: {
      accessToken: "a6fd8c9978dde3917183d07247b4f822",
      myShopifyDomain: "sunnylifeusa.myshopify.com"
    },
    metafields: {
      products: []
    }
  };
  Tagalys.setPlatformConfiguration(platformConfiguration);
};

TagalysCustomisations.initSearchSuggestions = function () {
  Tagalys.UIWidgets.SearchSuggestions.init("[data-search-input]", {
    searchResultsURL: "/search.html",
    templates: {
      widget: {
        options: {
          request: {
            products: { limit: 5 },
            collections: { limit: 10 },
            pages: { limit: 0 }
          },
          minimumCharactersToShowSuggestions: 2,
          maxRecentSearchesCount: 5,
          maxTotalSearchesCount: 10
        }
      },
      product: {
        render: function (html, args) {
          var props = args.props;
          var product = props.product;
          var helpers = props.helpers;

          var productOptions = helpers.getTemplateOptions('product');
          var productLink = productOptions.productPageUrl(product);

          // --- Official Okendo Product Review Widget Integration for JavaScript ---
          // As per the provided Liquid snippet for 'okendo-reviews-widget',
          // Okendo often pre-renders the widget HTML into a product metafield.
          // We will directly insert this snippet.

          // Construct the product ID string in the format Okendo expects for the widget
          const okendoProductId = `shopify-${product.id}`;

          // Get the pre-rendered HTML snippet from the product's Okendo metafields
          const reviewsWidgetSnippet = product?.metafields?.okendo?.ReviewsWidgetSnippet || '';

          return html`
                <div class="product">
                  <a class="product-link" href="${productLink}">
                    <span class="product-image-container">
                      ${product.featured_image ? html`<img class="product-image" src="${product.featured_image.src}" alt="${product.title}" />` : ''}
                    </span>
                    <div class="product-details">
                      <span class="product-name">${product.title}</span>
                      <span class="product-price">${helpers.formatCurrency(product.price)}</span>
                      <div
                        id="okendo-reviews-widget-${product.id}"
                        class="okendo-reviews-widget"
                        data-oke-widget
                        data-oke-reviews-product-id="${okendoProductId}"
                      >
                        <!-- Directly insert the pre-rendered HTML snippet from Okendo's metafield -->
                        ${html([reviewsWidgetSnippet])}
                      </div>
                    </div>
                  </a>
                </div>
              `;
        }
      }
    }
  });

  // Wait until the heading appears in the DOM
  function waitForHeading(selector, callback, timeout = 5000) {
    const startTime = Date.now();
    const check = setInterval(() => {
      const el = document.querySelector(selector);
      if (el) {
        clearInterval(check);
        callback(el);
      } else if (Date.now() - startTime > timeout) {
        clearInterval(check);
        console.warn('Heading not found within timeout.');
      }
    }, 100);
  }

  waitForHeading("#tagalys-namespace .plp-heading", function (headingEl) {
    var searchResultTitle = headingEl.textContent.trim();
    document.title = searchResultTitle;
  });
};

customElements.whenDefined("header-search").then(function () {
  const HeaderSearchProto = customElements.get("header-search").prototype;
  const originalAllowOutsideClick = HeaderSearchProto.allowOutsideClickForTarget;
  const originalHideForOutsideClick = HeaderSearchProto.hideForOutsideClickTarget;

  const isTagalysSearchTarget = function (target) {
    return Boolean(target?.closest?.(".tagalys-search-suggestions, #tagalys-namespace, .tagalys-namespace"));
  };

  // Let mousedown/click reach Tagalys links (focus-trap must not preventDefault).
  HeaderSearchProto.allowOutsideClickForTarget = function (target) {
    if (isTagalysSearchTarget(target)) {
      return true;
    }

    return originalAllowOutsideClick.call(this, target);
  };

  // Do not close the search panel before the link click navigates.
  HeaderSearchProto.hideForOutsideClickTarget = function (target) {
    if (isTagalysSearchTarget(target)) {
      return false;
    }

    return originalHideForOutsideClick.call(this, target);
  };
});

onTagalysReady(function () {
  const headerSearchIcon = document.querySelector(".header__search-link > a");
  const tagalysSearch = document.querySelector(".tagalys-search-suggestions");

  if (headerSearchIcon) {
    // Ensure aria-expanded is set if it is not already
    if (headerSearchIcon.getAttribute("aria-expanded") === null) {
      headerSearchIcon.setAttribute("aria-expanded", "false");
    }

    // Set up MutationObserver to detect changes to the aria-expanded attribute
    const observer = new MutationObserver(function (mutationsList) {
      for (let mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded') {
          // Re-query the tagalysSearch element in case it has been dynamically added
          const tagalysSearch = document.querySelector(".tagalys-search-suggestions");

          if (tagalysSearch) {
            const isExpanded = headerSearchIcon.getAttribute("aria-expanded") === "true";
            if (isExpanded) {
              tagalysSearch.style.display = "block";
            } else {
              tagalysSearch.style.display = "none";
            }
          } else {
            console.error('#tagalys-namespace not found');
          }
        }
      }
    });

    // Start observing changes to the aria-expanded attribute
    observer.observe(headerSearchIcon, { attributes: true });

    // Initial click to toggle aria-expanded
    headerSearchIcon.addEventListener("click", function (e) {
      // Prevent default behavior (if the link has a href)
      e.preventDefault();

      // Toggle aria-expanded between true and false
      const currentState = headerSearchIcon.getAttribute("aria-expanded") === "true";
      headerSearchIcon.setAttribute("aria-expanded", currentState ? "false" : "true");
    });
  } else {
    console.error('Required elements are missing from the DOM.');
  }
});

document.addEventListener("visitorConsentCollected", function () {
  if (typeof Tagalys !== "undefined" && TagalysCustomisations.setTagalysConfiguration) {
    TagalysCustomisations.setTagalysConfiguration();
  }
});

window.TagalysCustomisations = TagalysCustomisations;
